import { LOANREQUEST_STATUSES, SUB_STATUS_APPROVED } from 'cpool-constants';
import { z } from 'zod';

import { commonSchema } from '../common';

export const schemaApproved = z
    .object({
        status: z.literal(LOANREQUEST_STATUSES.APPROVED),
        subStatus: z.nativeEnum(SUB_STATUS_APPROVED).optional(),
    })
    .merge(commonSchema);
